import _parseInt from "F:\\vft-activities\\d2d\\node_modules\\@babel\\runtime-corejs2/core-js/parse-int";
import "core-js/modules/web.dom.iterable";
import _objectSpread from "F:\\vft-activities\\d2d\\node_modules\\@babel\\runtime-corejs2/helpers/esm/objectSpread";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters, mapState } from 'vuex';
import moment from 'moment';
import util from '@tencent/vft-common/util';
import eventBus from '../../../util/eventBus';
export default {
  computed: _objectSpread({}, mapState(['isLogin']), mapGetters(['now', 'eggType']), {
    visiblable: function visiblable() {
      var start = moment(this.setting.开始时间).valueOf();
      var end = moment(this.setting.结束时间).valueOf();
      return start <= this.now && this.now <= end;
    },
    list: function list() {
      return this.eggType.star_info_list || [];
    },
    tips: function tips() {
      return this.setting.通用tip;
      var date = moment(this.now).format('YYYY-MM-DD');
      var start = moment("".concat(date, " ").concat(this.setting.开始碰时间)).valueOf();

      if (this.now < start) {
        return this.setting.未开始tip;
      } else {
        var enabled = false;
        this.list.forEach(function (item) {
          if (item.star_is_collision) {
            enabled = true;
            return;
          }
        });

        if (enabled) {
          return this.setting.已开始tip;
        } else {
          return this.setting.已碰完tip;
        }
      }
    },
    startEgg: function startEgg() {
      return this.setting.蛋[_parseInt(Math.random() * this.setting.蛋.length)];
    }
  }),
  methods: {
    pen: function pen(item) {
      //      if (!this.isLogin) {
      //        this._openLogin()
      //        return
      //      }
      if (item.star_is_collision === 1) {
        window.sessionStorage.removeItem('d2d-shareCode');
        eventBus.$emit('peng', item.star_share_code); //        let url = window.location.href
        //        url = url.replace(/#.*$/, '')
        //        url = util.setUrlParam('shareCode', item.star_share_code, url)
        //        window.location.href = url
      }
    },
    tryToPause: function tryToPause() {
      if (this.player && this.player.getPlayerState() === 1) {
        this.player.pause();
      }
    },
    disabledBtnImg: function disabledBtnImg(item) {
      if (item.star_is_collision === 0) {
        return item.star_button || '//puui.qpic.cn/vupload/0/20190123_1548244388250_p697q7c8oeh.png/0';
      }

      if (item.star_is_collision === 2) {
        return 'https://puui.qpic.cn/vupload/0/20190201_1549011083558_zp51cwwid5n.png/0';
      }

      return '//puui.qpic.cn/vupload/0/20190123_1548244388250_p697q7c8oeh.png/0';
    }
  },
  mounted: function mounted() {
    var _this = this;

    util.loadScript('video_script', '//vm.gtimg.cn/tencentvideo/txp/js/txplayer.js', function () {
      _this.player = new Txplayer({
        containerId: 'video_container',
        vid: _this.setting.视频vid,
        width: '100%',
        height: '100%',
        poster: _this.setting.视频封面
      });
    });

    if (window.location.hash === '#star') {
      setTimeout(function () {
        console.log(_this.$el.getBoundingClientRect().top);
        window.document.body.scrollTop = 1307;
        document.documentElement.scrollTop = 1307; // window.scrollTo(0, this.$el.getBoundingClientRect().top)
      }, 2000);
    }
  },
  settingKey: '明星',
  setting: {
    背景图: 'https://puui.qpic.cn/vupload/0/20190124_1548327766590_n0dalcbfr6f.png/0',
    开始时间: '2019-01-16 00:00:00',
    结束时间: '2019-02-06 00:00:00',
    开始碰时间: '17:00',
    未开始tip: "<span class=\"highlight\">17:00</span>\u5F00\u542F\u660E\u661F\u78B0\u798F\u86CB\uFF0C\u642C\u597D\u5C0F\u677F\u51F3\uFF0C\u9759\u9759\u7B49\u5F85~",
    已开始tip: "\u5FEB\u6765\u548C\u7231\u8C46\u78B0\u86CB\uFF01\u53CC\u4EFD\u660E\u661F\u597D\u793C\u5728\u7B49\u4F60\uFF01",
    已碰完tip: "\u4ECA\u65E5\u660E\u661F\u86CB\u5DF2\u78B0\u5B8C\uFF0C\u660E\u5929\u518D\u89C1\u5440\uFF01",
    通用tip: '每天<span class="highlight">11:00</span>、<span class="highlight">17:00</span>、<span class="highlight">20:30</span>开启~',
    蛋: {
      type: 'array',
      default: ['https://puui.qpic.cn/vupload/0/20190124_1548328013286_ic1jsq5apq.png/0'],
      items: {
        type: 'image',
        default: 'https://puui.qpic.cn/vupload/0/20190124_1548328013286_ic1jsq5apq.png/0'
      }
    },
    视频vid: 'j03381r5gu5',
    视频封面: '//i.gtimg.cn/qqlive/images/20171117/i1510915974_1.jpg'
  }
};